import { render, staticRenderFns } from "./textMiddle.vue?vue&type=template&id=34fa519e&"
import script from "./textMiddle.vue?vue&type=script&lang=ts&"
export * from "./textMiddle.vue?vue&type=script&lang=ts&"
import style0 from "./textMiddle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports